var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0Z",
    fill: "#FF4D5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5581 15.4419L19.1161 20L14.5581 24.5581C14.314 24.8021 14.314 25.1979 14.5581 25.4419C14.8021 25.686 15.1979 25.686 15.4419 25.4419L20 20.8839L24.5581 25.4419C24.8021 25.686 25.1979 25.686 25.4419 25.4419C25.686 25.1979 25.686 24.8021 25.4419 24.5581L20.8839 20L25.4419 15.4419C25.686 15.1979 25.686 14.8021 25.4419 14.5581C25.1979 14.314 24.8021 14.314 24.5581 14.5581L20 19.1161L15.4419 14.5581C15.1979 14.314 14.8021 14.314 14.5581 14.5581C14.314 14.8021 14.314 15.1979 14.5581 15.4419Z",
    fill: "#616161"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1441_271683",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 12,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5581 15.4419L19.1161 20L14.5581 24.5581C14.314 24.8021 14.314 25.1979 14.5581 25.4419C14.8021 25.686 15.1979 25.686 15.4419 25.4419L20 20.8839L24.5581 25.4419C24.8021 25.686 25.1979 25.686 25.4419 25.4419C25.686 25.1979 25.686 24.8021 25.4419 24.5581L20.8839 20L25.4419 15.4419C25.686 15.1979 25.686 14.8021 25.4419 14.5581C25.1979 14.314 24.8021 14.314 24.5581 14.5581L20 19.1161L15.4419 14.5581C15.1979 14.314 14.8021 14.314 14.5581 14.5581C14.314 14.8021 14.314 15.1979 14.5581 15.4419Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1441_271683)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongResult);
export default __webpack_public_path__ + "static/media/Wrong-result.c087039a43f03bf79d7e7044a2f9b651.svg";
export { ForwardRef as ReactComponent };